/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input } from '@angular/core';
import { FeedbackRecipient, GeneratedReportFeedbackQuestionsSection, Organization } from '@app/app/shared/models';

@Component({
  selector: 'ptl-feedback-providers-report-questions-section',
  templateUrl: './questions-section.component.html',
  styleUrls: ['./questions-section.component.scss'],
})
export class QuestionsSectionComponent {
  @Input() section: GeneratedReportFeedbackQuestionsSection;

  @Input() language: string;
  @Input() organization: Organization;
  @Input() feedbackRecipient?: FeedbackRecipient;
}
